import React from "react";
import Layout from "@app/Layout";
import { Button, Col, Container, Row } from "react-bootstrap";
import "./style.scss";
import { Link } from "gatsby";
import { arrLidMagnit } from "@shared/ui/growth-marketing-playbook/utils";
import { StaticImage } from "gatsby-plugin-image";
import FormGrowthMarketingPlaybook from "@features/growth-marketing-playbook/Forms/FormGrowthMarketingPlaybook";

// SEO Meta
export const Head = () => (
  <>
    <html lang="en" />
    <title>41 growth marketing ideas to raise conversion on your website</title>
    <meta
      name="description"
      content="In this playbook, you’ll find tested and proven ideas for your growth tests, recommended settings and revenue forecast for each campaign."
    />
    <link rel="canonical" href="https://www.dashly.io/growth-marketing-playbook/" />
    <meta property="og:image" content="https://www.dashly.io/cover/en/growth-marketing-playbook.jpg" />
  </>
);

const GrowthMarketingPlaybook = () => {
  return (
    <Layout className="page lidmagnit-layout">
      <section className="hero px-md-4 lidmagnit-section" id="hero">
        <div className="hero-wrapper">
          <Container className="hero-lidmagnit__container">
            <Row className="hero-lidmagnit__row">
              <Col lg={6} className="order-2 order-lg-1 hero-lidmagnit__col">
                <StaticImage src="./hero-img.png" alt="" />
              </Col>

              <Col md={6} className="pt-5 pb-3 py-0 py-lg-5 order-1 order-lg-2 hero-lidmagnit__form">
                <div>
                  <h1>41&nbsp;growth marketing ideas to&nbsp;raise conversion on&nbsp;your website</h1>
                  <p className="mt-4 hero-text">
                    In&nbsp;this playbook, you&rsquo;ll find tested and proven ideas for your growth tests, recommended
                    settings and revenue forecast for each campaign.
                  </p>
                </div>
                <FormGrowthMarketingPlaybook />
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      <section className="lidmagnit-trust-section">
        <Container className="trust-container">
          <h2 className="trust-container--title h2">Ideas tested by</h2>
          <ul className="trust-container__logo-list">
            {arrLidMagnit.map((logo, index) => (
              <li key={logo.alt + index} className="trust-container__logo-list--item">
                <img src={logo.logo} alt={logo.logo} className="mw-100 logo" loading="eager" />
              </li>
            ))}
          </ul>
        </Container>
      </section>

      <section>
        <Container className="lidmagnit-free">
          <h2 className="lidmagnit-free__title">Launch the first campaign in 15 mins with Dashly</h2>
          <Link className="lidmagnit-free__button" to="/panel/unauthorized/register">
            Sign up for a free trial
          </Link>
        </Container>
      </section>
    </Layout>
  );
};

export default GrowthMarketingPlaybook;
